import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { Consumer } from './models/ConsumerModels';

export class ApiConsumer extends ApiHexaBase {
  public static consumerBaseUrl(
    id: string | number,
    application_id: string | number
  ): string {
    return `${ApiHexaBase.baseUrl}/customers/${id}/applications/${application_id}/consumers`;
  }

  public static async index(
    id: string | number,
    application_id: string | number
  ) {
    const response = await ApiBase.get(
      this.consumerBaseUrl(id, application_id)
    );

    return response.data.data as Consumer[];
  }

  public static async create(
    id: string | number,
    application_id: string | number
  ) {
    const response = await ApiBase.post(
      this.consumerBaseUrl(id, application_id)
    );

    return response.data.data as Consumer;
  }

  public static async update(
    id: string | number,
    application_id: string | number,
    consumer_id: string | number,
    data: Partial<Consumer>
  ) {
    const response = await ApiBase.post(
      `${this.consumerBaseUrl(id, application_id)}/${consumer_id}`,
      data
    );
    return response.data.data as Consumer;
  }
}
